import React from 'react';
import {ReactComponent as EditIcon} from '../../../../../../../../assets/main/groups/main-top/edit.svg';
import {useAppSelector} from "common/hook";
import {ROLE_TEACHER} from "entities/constants/constants";


interface CefrLevelsProps {
    beginLanguageLevel: string | undefined;
    currentLanguageLevel: string | undefined;
    onClickHandler?: () => void;
    editVisible: boolean;
    arrowIcon1: React.ReactNode;
    arrowIcon2: React.ReactNode;
}

const cefrLevels = ['A0', 'A1', 'A2', 'B1', 'B2', 'C1', 'C2'];

const isBetweenLevels = (
    level: string,
    beginLevel: string | undefined,
    currentLevel: string | undefined
) => {
    if (!beginLevel || !currentLevel) {
        return false;
    }
    const levelIndex = cefrLevels.indexOf(level);
    const beginIndex = cefrLevels.indexOf(beginLevel);
    const currentIndex = cefrLevels.indexOf(currentLevel);
    return levelIndex >= beginIndex && levelIndex <= currentIndex;
};


export const CefrLevelsComponent: React.FC<CefrLevelsProps> = (
    {
        beginLanguageLevel,
        currentLanguageLevel,
        onClickHandler,
        editVisible,
        arrowIcon1,
        arrowIcon2,
    }
) => {
    const roleType = useAppSelector((state) => state.role.roleType);

    return (
        <div className="cefr-levels">
            {cefrLevels.map((level, index) => {
                const hasSelectedCefrClass = isBetweenLevels(level, beginLanguageLevel, currentLanguageLevel);
                return (
                    <div
                        key={level}
                        className={`cefr-level ${hasSelectedCefrClass ? 'selected-cefr' : ''}`}
                    >
                        {level}
                        {index !== cefrLevels.length - 1 && (
                            hasSelectedCefrClass ? arrowIcon2 : arrowIcon1
                        )}
                    </div>
                );
            })}
            {editVisible && roleType === ROLE_TEACHER && (
                <span className="small-edit-btn pointer-elem" onClick={onClickHandler}>
                    <EditIcon/>
                </span>
            )}
        </div>
    );
};